export enum EditInfoPageMode {
  Create = 'create',
  Update = 'update',
}
